import { ReceivingReportRecord } from '../../../../types/ReceivingReport';
import React from 'react';
import { Tabs, TabsProps } from 'antd';
import ReceivingReportInfoTable from './ReceivingReportInfoTable';
import ReceivingReportInfoReceivingTable from './ReceivingReportInfoReceivingTable';
import ReceivingRequestSummaryTable from './ReceivingRequestSummaryTable';

interface ReceivingReportInfoTabsProp {
  data?: ReceivingReportRecord;
}

const ReceivingReportInfoTabs: React.FC<ReceivingReportInfoTabsProp> = ({
  data,
}) => {
  const items: TabsProps['items'] = [
    {
      key: '1',
      label: 'Movements',
      children: (
        <ReceivingReportInfoTable
          rrMovements={data?.movements}
          recordId={data?.id}
          statusRecord={data?.status}
        />
      ),
    },
    {
      key: '2',
      label: 'Receiving',
      children: (
        <ReceivingReportInfoReceivingTable issuanceTable={data?.issuance} />
      ),
    },
    {
      key: '3',
      label: 'Summary',
      children: (
        <ReceivingRequestSummaryTable summaryData={data?.summary || []} />
      ),
    },
  ];

  return (
    <>
      <Tabs defaultActiveKey="1" items={items} />
    </>
  );
};

export default ReceivingReportInfoTabs;
